import React from 'react'
import PropTypes from 'prop-types'
import { ROUTES } from '../../routes'
import { Link, generatePath } from 'react-router-dom'
import dayjs from '../../utilities/dayjs'
import { getRecurringServiceOn } from './util'
import CursorPagination from '../cursor-pagination'
import { enumToTitleCase } from '../../utilities/stringUtilities'
import styles from './index.module.scss'
import cn from 'classnames'

export default function RecurringServicesTable ({ recurringServices, onPageRequest, fakeCount, job }) {
  const recurringServiceParams = new URLSearchParams({
    job_id: job?.id,
    jobCustomId: job?.customId,
    serviceFrequency: 'RECURRING'
  })

  return (
    <div className='dis-panel'>
      <div className='dis-panel-header'>
        <div>
          <div className={styles.header}>
            <h4>Recurring Services - {recurringServices?.totalCount ?? 0} services</h4>
            {job &&
              <Link to={`/hauler/tickets/new?${recurringServiceParams.toString()}`} className={cn('btn btn-lg btn-primary', styles.button)}>
                <span>Create Recurring Tickets</span>
                <i className='material-icons pull-right thumbster-button-icon no-margin-bs-xs'>add_circle</i>
              </Link>
            }
          </div>
        </div>
      </div>
      <div className='dis-panel-body table-responsive'>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th>ID</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Service Interval</th>
              <th>Service On</th>
              <th>Ticket Type</th>
              <th>Asset Type</th>
              <th>Manage Recurring Service</th>
            </tr>
          </thead>
          <tbody>
            { recurringServices?.nodes?.length === 0
              ? (
                <tr>
                  <td colSpan={8}>
                    <h4 className='text-center'>No Recurring Services</h4>
                  </td>
                </tr>
                )
              : recurringServices?.nodes?.map(recurringService => {
                const recurringServicePath = `${generatePath(ROUTES.editTicket, { id: recurringService.id })}?serviceFrequency=RECURRING`

                return (
                  <tr key={recurringService.id}>
                    <td>
                      <Link to={recurringServicePath}>
                        {recurringService.customId}
                      </Link>
                    </td>
                    <td>
                      {recurringService.startDate ? dayjs(recurringService.startDate).format('MMM DD, YYYY') : '--'}
                    </td>
                    <td>
                      {recurringService.endDate ? dayjs(recurringService.endDate).format('MMM DD, YYYY') : '--'}
                    </td>
                    <td>
                      {recurringService.serviceInterval ? enumToTitleCase(recurringService.serviceInterval) : 'None'}
                    </td>
                    <td>
                      {getRecurringServiceOn(recurringService)}
                    </td>
                    <td>
                      {recurringService.ticketType.name} ({recurringService.ticketType.shortCode})
                    </td>
                    <td>
                      {recurringService.resourceType.name} ({recurringService.resourceType.shortCode})
                    </td>
                    <td>
                      <Link to={recurringServicePath}>
                        <i className='material-icons medium-icon'>info</i>
                      </Link>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
        {recurringServices?.totalCount > 0 &&
          <CursorPagination
            pageInfo={recurringServices.pageInfo}
            totalCount={recurringServices.totalCount}
            onPageRequest={onPageRequest}
            fakeCount={fakeCount}
          />
        }
      </div>
    </div>
  )
}
RecurringServicesTable.propTypes = {
  recurringServices: PropTypes.object.isRequired,
  onPageRequest: PropTypes.func.isRequired,
  fakeCount: PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired
  }),
  job: PropTypes.object
}
